module.exports = __webpack_public_path__ + "img/Profile-17.1acb929c.png";